// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sg-z","play":"Tg-z"};